import { provideHttpClient, withXhr } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideRouter, withRouterConfig } from '@angular/router';

import { WINDOW, windowFactory } from '@spaces-ui/browser-window';
import { ENVIRONMENT } from '@spaces-ui/environment';

import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';

const environmentProvider = {
  provide: ENVIRONMENT,
  useValue: environment,
};

export const appConfig: ApplicationConfig = {
  providers: [
    environmentProvider,
    // Keep Angular <22 param inheritance (default became 'always' in v22) (SPA-840).
    provideRouter(appRoutes, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    provideHttpClient(withXhr()),
    provideNativeDateAdapter(),
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { showDelay: 500, hideDelay: 0, position: 'above' },
    },
    {
      provide: WINDOW,
      useFactory: windowFactory,
    },
  ],
};
